module.exports = __webpack_public_path__ + "static/media/78-car.58d662dd.jpg";